module.exports = "/dist//ionicons.eot?19e65b89cee273a249fba4c09b951b74";